require('./helpers/bundle-manifest').register(JSON.parse("{\"awEuB\":\"app.js\",\"aXQLv\":\"flexsearch.bundle.b3d1c2f5.js\"}"));